module.exports = __webpack_public_path__ + "static/media/Bg-iphone3-en.e55a980e.png";